module.exports = __webpack_public_path__ + "static/media/favicon.b0537b6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon.svg
// module id = 778
// module chunks = 0